import { render } from "./terms-conditions.vue?vue&type=template&id=63f6d4be&scoped=true"
import script from "./terms-conditions.vue?vue&type=script&lang=js"
export * from "./terms-conditions.vue?vue&type=script&lang=js"

import "./terms-conditions.vue?vue&type=style&index=0&id=63f6d4be&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63f6d4be"]])

export default __exports__